import gql from 'graphql-tag';

export const describeJobExecutionQuery = gql`
  query ($jobId: String, $deviceId: Int) {
    describeJobExecution (jobId: $jobId, deviceId: $deviceId) {
       status
    }
  }
`
